import type { RobotEvent } from '@fabricos/protocol-ts';

/**
 * Shared event presentation — one summary/colour/module vocabulary for every
 * surface that renders robot events (right-panel Events feed, TopBar events
 * center, future module feeds).
 */

export function eventSummary(e: RobotEvent): string {
  switch (e.kind) {
    case 'mode_changed':
      return `mode → ${e.mode}`;
    case 'arm_state_changed':
      return e.armed ? 'armed' : 'disarmed';
    case 'waypoint_reached':
      return `waypoint #${e.seq + 1} reached`;
    case 'gps_fix_changed':
      return `gps ${e.fix} · ${e.satellites} sats`;
    case 'battery_low':
    case 'battery_critical':
      return `${e.kind.replace('_', ' ')} · ${Math.round(e.remaining_pct)}%`;
    case 'failsafe_triggered':
      return `failsafe: ${e.reason}`;
    case 'error':
      return `${e.code}: ${e.message}`;
    case 'text':
      return e.message;
    case 'disconnected':
      return e.reason ? `disconnected: ${e.reason}` : 'disconnected';
    default:
      return e.kind.replace(/_/g, ' ');
  }
}

export function eventSeverityColor(e: RobotEvent): string {
  return e.severity === 'critical'
    ? 'var(--color-status-critical)'
    : e.severity === 'warning'
      ? 'var(--color-status-warn)'
      : 'var(--color-fg-secondary)';
}

export function fmtClock(ts_ms: bigint): string {
  return new Date(Number(ts_ms)).toLocaleTimeString([], { hour12: false });
}
